// extracted by mini-css-extract-plugin
module.exports = {"story":"story--3Dp9Q","stretch":"stretch--39LPK","loader":"loader--1uF-R"};